import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URL } from '../constants'
import { getTokenFromLocalStorage } from '../../utils'

export const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/users`,
    headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
  }),
  endpoints: (builder) => ({
    getUser: builder.query<any, void>({
      query: () => ({
        url: 'me'
      })
    }),
    patchUser: builder.mutation({
      query: (user) => ({
        method: 'PATCH',
        body: user,
        url: 'me'
      })
    })
  })
})

export const { useGetUserQuery, useLazyGetUserQuery, usePatchUserMutation } = usersApi
